import script from "./ProjectPhasesPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectPhasesPage.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectPhasesPage.vue?vue&type=style&index=0&id=fbc0020e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbc0020e"]])

export default __exports__